<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="pl-12 pr-12 col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs" id="v-step-4"></v-breadcrumbs>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right">
            <v-btn
              color="#1B437C"
              id="v-step-0"
              depressed
              dark
              @click="(dialogAdd = true), validate('ADD');"
            >
              <v-icon left>mdi-text-box-plus</v-icon>
              เพิ่ม
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-dialog v-model="dialogAdd" persistent max-width="40%">
            <v-card>
              <v-form ref="form_add" v-model="validAdd" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click="(dialogAdd = false), clearDataAdd();"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-row justify="center">
                      <v-col cols="5" class="text-center">
                        <v-col class="text-center">
                          <v-img
                            class="v-margit_img_reward"
                            :src="require('@/assets/GroupLevel.svg')"
                            max-width="330"
                          ></v-img>
                        </v-col>
                      </v-col>

                      <v-col cols="6" class="v-margit_text_add mt-1">
                        <v-col class="text-center">
                          <v-img
                            class="v_text_add"
                            :src="require('@/assets/Grouptitle.svg')"
                          ></v-img>
                        </v-col>
                        <v-col cols="12">
                          <v-img
                            aspect-ratio="6"
                            contain
                            :src="formAdd.pictureUrlPreview"
                            :rules="[rules.required]"
                          ></v-img>
                          <v-file-input
                            outlined
                            dense
                            required
                            counter
                            show-size
                            :rules="[rules.required]"
                            accept="image/png, image/jpeg, image/bmp"
                            prepend-icon="mdi-camera"
                            label="Image"
                            @change="selectImg"
                            v-model="filesAdd"
                          ></v-file-input>
                          <v-text-field
                            v-model="formAdd.name"
                            label="ชื่อระดับสมาชิก"
                            placeholder="ชื่อ Level"
                            dense
                            outlined
                            required
                            :rules="[rules.required]"
                          ></v-text-field>
                          <VuetifyMoney
                            v-model="formAdd.point"
                            label="ต้องมีคะแนนเท่าไหร่ถึงจะได้ระดับนี้"
                            dense
                            outlined
                            required
                            :rules="[rules.required]"
                            v-bind:options="options2"
                          />
                          <v-textarea
                            v-model="formAdd.priviledge"
                            :rules="[rules.required]"
                            outlined
                            name="input-7-4"
                            label="สิทธิประโยชน์"
                            row="1"
                            counter
                          ></v-textarea>
                        </v-col>
                        <v-row>
                          <v-spacer></v-spacer>
                          <v-col cols="6" class="d-flex justify-center">
                            <v-color-picker
                              :hide-canvas="!canvas"
                              hide-mode-switch
                              mode="hexa"
                              v-model="formAdd.color"
                              class="ma-2"
                            ></v-color-picker>
                          </v-col>
                          <v-spacer></v-spacer>
                        </v-row>
                        <v-col id="margin">
                          <v-row justify="center" id="v-step-1">
                            <v-btn
                              elevation="2"
                              x-large
                              color="#173053"
                              dark
                              :disabled="!validAdd"
                              :loading="loadingAdd"
                              @click="addData()"
                            >
                              <v-icon left>mdi-checkbox-marked-circle</v-icon>
                              เพิ่ม
                            </v-btn>
                          </v-row>
                        </v-col>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent max-width="40%">
            <v-card class="text-center">
              <v-form ref="form_update" v-model="validUpdate" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click="(dialogEdit = false), clearDataUpdate();"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-row justify="center">
                      <v-col cols="10" class="text-center">
                        <v-img
                          class="v_text_edit"
                          :src="require('@/assets/GroupEditTitle.svg')"
                        ></v-img>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="10" class="text-center">
                        <v-img
                          aspect-ratio="6"
                          contain
                          :src="formUpdate.pictureUrlPreview"
                        ></v-img>
                        <!-- <v-avatar size="100px"><img alt="Avatar" :src="formAdd.pictureUrl"></v-avatar> -->
                        <br />
                        <v-file-input
                          required
                          counter
                          show-size
                          accept="image/png, image/jpeg, image/bmp"
                          prepend-icon="mdi-camera"
                          label="Image"
                          @change="selectImgUpdate"
                          v-model="filesUpdate"
                        ></v-file-input>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="10" class="ml-8">
                        <v-row style="height: 15px">
                          <v-subheader id="subtext"
                            >ชื่อระดับสมาชิก</v-subheader
                          >
                        </v-row>
                        <v-row style="height: 70px">
                          <v-text-field
                            v-model="formUpdate.name"
                            placeholder="ชื่อ Card"
                            dense
                            required
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="ml-8">
                        <v-row style="height: 15px">
                          <v-subheader id="subtext"
                            >ต้องมีคะแนนเท่าไหร่ ถึงจะได้ระดับนี้</v-subheader
                          >
                        </v-row>
                        <v-row style="height: 70px">
                          <VuetifyMoney
                            v-model="formUpdate.point"
                            placeholder="Point"
                            dense
                            required
                            :rules="[rules.required]"
                            v-bind:options="options2"
                          />
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-col cols="12">
                      <v-row style="height: 35px" class="ml-1">
                        <v-subheader id="subtext">สิทธิประโยชน์</v-subheader>
                      </v-row>
                      <v-row class="ml-2">
                        <v-textarea
                          auto-grow
                          outlined
                          rows="2"
                          name="input-7-4"
                          placeholder="Priviledge"
                          counter
                          dense
                          required
                          :rules="[rules.required]"
                          v-model="formUpdate.priviledge"
                        ></v-textarea>
                      </v-row>
                    </v-col>

                    <v-row>
                      <v-spacer></v-spacer>
                      <v-col cols="6">
                        <v-color-picker
                          :hide-canvas="!canvas"
                          hide-mode-switch
                          mode="hexa"
                          v-model="formUpdate.color"
                        ></v-color-picker>
                      </v-col>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
              <v-card-actions id="v-step-3">
                <v-col id="margin">
                  <v-row justify="center">
                    <v-btn
                      elevation="2"
                      x-large
                      dark
                      color="#173053"
                      :disabled="!validUpdate"
                      :loading="loadingEdit"
                      @click="editData()"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      บันทึก
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end edit -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="รหัส Card*"
                        v-model="formUpdate.levelId"
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  class="btn-color"
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  color="red darken-1"
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end delete -->

          <!-- data table -->
          <v-col cols="12">
            <!-- <v-card
              class="mx-auto card-index"
              width="400"
              height="200"
              color="#EF5350"
            >
              <div style="background-color:gray" class="rotate">sdsd</div>
              {{name}}
            </v-card>
            <br /><br /><br /> -->
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.point`]="{ item }">
                    {{ formatNumber(item.point) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_dateNotime(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_dateNotime(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.priviledge`]="{ item }">
                    <nl2br tag="p" :text="item.priviledge" />
                  </template>
                  <template v-slot:[`item.color`]="{ item }">
                    <v-card
                      class="mx-auto card-index div_color"
                      width="120"
                      height="70"
                      color="#E0E0E0"
                    >
                      <div
                        :style="'background-color:' + item.color"
                        class="rotate"
                      ></div>
                    </v-card>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          dark
                          id="v-step-2"
                          x-small
                          @click.stop="getDataById(item, 'edit')"
                        >
                          <v-icon dark> mdi-tools </v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไขข้อมูล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          dark
                          fab
                          x-small
                          @click.stop="getDataById(item, 'delete')"
                        >
                          <v-icon> mdi-delete </v-icon>
                        </v-btn>
                      </template>
                      <span>ลบข้อมูล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import VuetifyMoney from '../VuetifyMoney.vue'
// import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
// import XLSX from 'xlsx' // import xlsx
// import readXlsxFile from 'read-excel-file'
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney
    // downloadExcel: JsonExcel,
    // XLSX,
    // readXlsxFile
  },
  created () {
    // setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      PK: '',
      returnLink: '/Master/Level',
      path: '/level/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'Level',
          disabled: false,
          href: '/Master/Level'
        }
      ],
      options2: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 9,
        precision: 0
      },
      // End Menu Config
      dataReady: true,
      canvas: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      code: 'AGE_', // Generate Code
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      // Search Advanced
      search: {
        masAgeCode: '',
        masAgeName: '',
        create_date_start: '',
        create_date_end: '',
        last_date_start: '',
        last_date_end: ''
      },
      color: '',
      formAdd: {
        name: '',
        point: 0,
        priviledge: '',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: this.$session.getAll().data.shopId,
        pictureUrl: '',
        pictureUrlPreview: '',
        color: ''
      },
      formUpdate: {
        levelId: '',
        name: '',
        point: 0,
        priviledge: '',
        LAST_USER: '',
        shopId: '',
        pictureUrl: '',
        pictureUrlPreview: '',
        color: ''
      },
      rules: {
        numberRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: (value) => value.length <= 10 || 'Max 10 characters',
        IDcardRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: (value) => !!value || 'กรุณากรอก.',
        counterIDcard: (value) => value.length <= 13 || 'Max 13 characters',
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'ID', value: 'levelId' },
        { text: 'ระดับ', value: 'name' },
        { text: 'คะแนน', value: 'point' },
        { text: 'สิทธิ์ที่ได้รับ', value: 'priviledge' },
        { text: 'สีของระดับ', value: 'color' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      validAdd: true,
      validUpdate: true,
      filesAdd: null,
      filesUpdate: null,
      // End Data Table Config
      //   loading
      loadingAdd: false,
      loadingEdit: false
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // this.getGetToken(this.DNS_IP)
    this.dataReady = false
    // Get Data
    await this.getDataGlobal(
      this.DNS_IP,
      this.path,
      this.session.data.shopId,
      this.returnLink
    )
    if (this.$route.query.tour) {
      if (this.$route.query.tour === 'true') {
        this.$tours['myTour'].start()
      } else {
        this.$tours['myTourPage'].start()
      }
    }
  },
  methods: {
    selectImgUpdate (event) {
      if (this.filesUpdate != null) {
        this.formUpdate.pictureUrlPreview = URL.createObjectURL(
          this.filesUpdate
        )
      } else {
        this.formUpdate.pictureUrlPreview = ''
      }
      // console.log(event)
    },
    selectImg (event) {
      if (this.filesAdd) {
        this.formAdd.pictureUrlPreview = URL.createObjectURL(this.filesAdd)
      } else {
        this.formAdd.pictureUrlPreview = ''
      }
      // console.log(event)
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async searchDataAll () {
      //
      //
      // สำหรับ ค้นหาแบบ LIKE Search
      // ต้องระบุ Field ที่จะส่งไปให้ตรงกับ Model
      //
      var search =
        '?levelId=' +
        this.searchAll +
        '&name=' +
        this.searchAll +
        '&Point=' +
        this.searchAll +
        '&priviledge=' +
        this.searchAll
      this.dataReady = false
      this.searchDataAllGlobal(this.DNS_IP, this.path, search, this.returnLink)
    },
    async getDataById (item, type) {
      //
      //
      // สำหรับ เรียกข้อมูล ใส่ form Update / Delete
      //
      //
      // Get ID /main.js
      this.dataReady = false
      await this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        'levelId',
        item.levelId,
        this.returnLink
      )
      this.formUpdate.pictureUrlPreview = this.formUpdate.pictureUrl
      if (type === 'edit') {
        this.dialogEdit = true
        this.validate('UPDATE')
      } else if (type === 'delete') {
        this.dialogDelete = true
      }
    },
    async addData () {
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.loadingAdd = true
          this.formAdd.CREATE_USER = this.session.data.userName
          this.formAdd.LAST_USER = this.session.data.userName
          if (this.formAdd.point === '') {
            this.formAdd.point = 0
          }
          const _this = this
          let params = new FormData()
          params.append('file', this.filesAdd)

          await axios
            .post(this.DNS_IP + `/file/upload/reward`, params)
            .then(function (response) {
              _this.formAdd.pictureUrl = response.data
              console.log('url Pic', response.data)
            })
          delete this.formAdd['pictureUrlPreview']
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "add",
              this.formAdd
              //   {
              //     headers: {
              //       'Application-Key': this.$session.getAll().ApplicationKey
              //     }
              //   }
            )
            .then(async (response) => {
              // Debug response
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)

              // this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogAdd = false

              // Load Data
              await this.clearDataAdd()
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              this.loadingAdd = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function addDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              this.dataReady = true
            })
        })
        .catch((error) => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async editData () {
      //   console.log(this.formUpdate.color)
      // this.editDataGlobal(this.DNS_IP, this.path, this.PK, this.formUpdateItem)
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.loadingEdit = true
          this.formUpdate.LAST_USER = this.session.data.userName
          var ID = this.formUpdate.levelId
          if (this.filesUpdate) {
            const _this = this
            let params = new FormData()
            params.append('file', this.filesUpdate)

            await axios
              .post(this.DNS_IP + `/file/upload/reward`, params)
              .then(function (response) {
                _this.formUpdate.pictureUrl = response.data
                console.log('url Pic', response.data)
              })
          } else {
            this.formUpdate.pictureUrl = this.formUpdate.pictureUrlPreview
          }
          delete this.formUpdate['pictureUrlPreview']
          delete this.formUpdate['levelId']
          delete this.formUpdate['LAST_DATE']
          delete this.formUpdate['CREATE_DATE']
          if (this.formUpdate.point === '') {
            this.formUpdate.point = 0
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "edit/" + ID,
              this.formUpdate
              // {
              //   headers: {
              //     'Application-Key': this.$session.getAll().ApplicationKey
              //   }
              // }
            )
            .then(async (response) => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              // this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false

              // Load Data
              // await this.reloadData()
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              this.clearDataUpdate()
              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              this.loadingEdit = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData () {
      this.formUpdate.LAST_USER = this.session.data.userName
      console.log('DELETE PK : ', this.formUpdate.levelId)
      //
      //
      // สำหรับ ลบข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนลบล่าสุด
      //
      // this.formUpdate.LAST_USER = this.$session.getAll().data.userName
      this.dataReady = false
      this.deleteDataGlobal(
        this.DNS_IP,
        this.path,
        this.formUpdate.levelId,
        this.session.data.shopId,
        '',
        this.returnLink
      )
    },
    async clearDataAdd () {
      this.formAdd.name = ''
      this.formAdd.point = 0
      this.formAdd.priviledge = ''
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.formAdd.shopId = this.$session.getAll().data.shopId
      this.formAdd.pictureUrl = ''
      this.formAdd.pictureUrlPreview = ''
      this.filesAdd = null
      this.formAdd.color = ''
    },
    async clearDataUpdate () {
      this.formUpdate.levelId = ''
      this.formUpdate.name = ''
      this.formUpdate.point = 0
      this.formUpdate.priviledge = ''
      this.formUpdate.LAST_USER = ''
      this.formUpdate.shopId = ''
      this.formUpdate.pictureUrl = ''
      this.formUpdate.pictureUrlPreview = ''
      this.filesUpdate = null
      this.formUpdate.color = ''
    }
  }
}
</script>
<style scope>
.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, 0.4);
}
#margin {
  margin-top: 50px;
  margin-bottom: 40px;
}
.v_text_edit {
  width: 255px;
  height: 52px;
}
.div_color {
  width: 5rem;
  height: 2.5rem;
  display: block;
  border-radius: 11px;
}
.card-index {
  overflow: hidden;
  position: relative;
}
.rotate {
  width: 10px;
  height: 150px;
  position: absolute;
  top: -50px;
  transform: rotate(30deg);
  -webkit-transform: rotate(45deg);
}
</style>



// WEBPACK FOOTER //
// src/components/Master/Level.vue